import { render, staticRenderFns } from "./recommend_item_topic.vue?vue&type=template&id=53a806ec&scoped=true&"
import script from "./recommend_item_topic.vue?vue&type=script&lang=ts&"
export * from "./recommend_item_topic.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item_topic.vue?vue&type=style&index=0&id=53a806ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a806ec",
  null
  
)

export default component.exports